const scope = {
    name_exists: 'El nombre del ámbito {{name}} ya está en uso',
    name_with_space: 'El nombre del ámbito no puede contener espacios.',
};
export default scope;
